var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_916_7987",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.99292,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_916_7987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "featured_video",
    d: "M3.75 11.4929H10.5V6.24292H3.75V11.4929ZM3 15.9929C2.5875 15.9929 2.23438 15.846 1.94063 15.5523C1.64688 15.2585 1.5 14.9054 1.5 14.4929V5.49292C1.5 5.08042 1.64688 4.72729 1.94063 4.43354C2.23438 4.13979 2.5875 3.99292 3 3.99292H15C15.4125 3.99292 15.7656 4.13979 16.0594 4.43354C16.3531 4.72729 16.5 5.08042 16.5 5.49292V14.4929C16.5 14.9054 16.3531 15.2585 16.0594 15.5523C15.7656 15.846 15.4125 15.9929 15 15.9929H3ZM3 14.4929H15V5.49292H3V14.4929Z",
    fill: "#F6F6F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindow);
export default __webpack_public_path__ + "static/media/window.a4bb932b0b41d0ad1e81cf87f465807e.svg";
export { ForwardRef as ReactComponent };